// src/components/canine-teeth/ImageUpload.js

import React, { useState, useEffect, useCallback } from 'react';
import ImageSelector from './ImageSelector';
import '../tools.css';
import SavedSessionsGallery from './SavedSessionsGallery';
import { auth, db } from '../../firebase';
// eslint-disable-next-line no-unused-vars
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { Circles } from 'react-loader-spinner';

function ImageUpload() {
  const [userEmail, setUserEmail] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [step, setStep] = useState(1);
  const [tipo, setTipo] = useState('');
  const [posizione, setPosizione] = useState('');
  const [sesso, setSesso] = useState('');
  const [realAge, setRealAge] = useState('');

  const [loadedSession, setLoadedSession] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [user, setUser] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [userInfo, setUserInfo] = useState(null);

  const [sessionsCount, setSessionsCount] = useState(0);
  const [isAuthLoading, setIsAuthLoading] = useState(true);
  const navigate = useNavigate();

  const handleSaveSesso = useCallback(() => {
    if (sesso) {
      console.log('Sex selected in ImageUpload:', sesso); // Debug
      setStep(3); // Move to the next step
    } else {
      alert('Please select sex');
    }
  }, [sesso]);


  // Authentication state handling
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUser(user);
        setUserEmail(user.email);
        try {
          const docRef = doc(db, 'users', user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
              setUserInfo(docSnap.data());
            } else {
              console.warn('No user document found!');
              setUserInfo(null);
            }
        } catch (error) {
          console.error('Error fetching user data:', error);
          setUserInfo(null);
        }
      } else {
        setUser(null);
        navigate('/');
      }
      setIsAuthLoading(false); // Autenticazione completata
    });

  return () => unsubscribe();
  }, [navigate]);

  // Funzione di logout
  // const handleLogout = useCallback(async () => {
  //   try {
  //     await signOut(auth);
  //     navigate('/');
  //   } catch (error) {
  //     console.error('Errore durante il logout:', error);
  //     alert('Si è verificato un errore durante il logout. Riprova.');
  //   }
  // }, [navigate]);

  // Image selection handling
  const handleImageChange = useCallback((e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setStep(2);
    }
  }, []);


  // Select a saved session
  const handleSelectSession = useCallback((session) => {
    setImageFile(null);
    setTipo(session.tipo || '');
    setSesso(session.sesso || '');
    setPosizione(session.posizione || '');
    setRealAge(session.realAge || '');
    setLoadedSession(session);
    setStep(3);
  }, []);

  // Update sessions count
  const updateSessionsCount = useCallback(() => {
    setSessionsCount((prev) => prev + 1);
  }, []);

  // Auth loading state handling
  if (isAuthLoading) {
  return (
    <div className="loading-overlay">
      <div className="loading-content">
        <Circles height="80" width="80" color="#ffffff" ariaLabel="loading" />
        <p>Loading... Syncing profile info</p>
      </div>
    </div>
  );
}

  // Rendering condizionale in base allo stato
  return (
    <div className="tool-container">
      {step === 1 && (
        <div className="upload-step">
          <h2 className="step-title">Step 1: Upload Image</h2>
          <input type="file" accept="image/*" onChange={handleImageChange} />
          {imageFile && <p>Selected image: {imageFile.name}</p>}
        </div>
      )}

      {step === 2 && (
        <div className="selection-step boxed">
          <h2 className="step-title">Step 2: Select Sex</h2>
          <h4>Selected image: {imageFile.name}</h4>

          <div className="selection-group">
            <h4>Select Sex</h4>
            <label>
              <input
                type="radio"
                value="M"
                checked={sesso === 'M'}
                onChange={(e) => setSesso(e.target.value)}
              />
              Male
            </label>
            <br />
            <label>
              <input
                type="radio"
                value="F"
                checked={sesso === 'F'}
                onChange={(e) => setSesso(e.target.value)}
              />
              Female
            </label>
          </div>

          <div className="selection-group">
            <h4>Real Age (Optional)</h4>
            <input
              type="number"
              min="0"
              value={realAge}
              onChange={(e) => setRealAge(e.target.value)}
              placeholder="Enter real age (optional)"
              style={{ padding: '8px', marginTop: '5px', width: '100%', maxWidth: '200px' }}
            />
          </div>

          <button onClick={handleSaveSesso} className="save-button">
            Save Data
          </button>
        </div>
      )}

      {step >= 3 && (imageFile || loadedSession) && (
        <ImageSelector
          imageFile={imageFile}
          userEmail={userEmail}
          tipo={tipo}
          posizione={posizione}
          sesso={sesso} // Passa 'sesso' qui
          realAge={realAge} // Passa 'realAge' qui
          selectionRequired={false}
          maxTotalPoints={2}
          colorCategories={['blue']}
          categoryColors={{ blue: 'blue' }}
          passCategoryToAnnotation={true}
          maxPointsPerCategory={{ blue: 3 }}
          useLeftRightInNames={true}
          categoriesToAnnotate={['blue']}
          loadedSession={loadedSession}
          updateSessionsCount={updateSessionsCount}
        />
      )}

      {step === 1 && (
        <SavedSessionsGallery
          onSelectSession={handleSelectSession}
          sessionsCount={sessionsCount}
          userEmail={userEmail}
        />
      )}
    </div>
  );
}

export default ImageUpload;
